import { useEffect, useRef, useState } from 'react';

interface UseAutoLoopSelectOptions<T> {
  list: T[];
  interval?: number;
  getId: (item: T) => number;
}

export function useAutoLoopSelect<T>({ list, interval = 3000, getId }: UseAutoLoopSelectOptions<T>) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedId, setSelectedId] = useState<number>();

  const timerRef = useRef<number | null>(null);
  const pausedRef = useRef(false);

  /** 清理定时器 */
  const clearTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  /** 启动轮播（从 currentIndex 继续） */
  const startLoop = () => {
    if (!list.length) return;

    clearTimer();

    timerRef.current = window.setInterval(() => {
      setCurrentIndex(prev => {
        const next = (prev + 1) % list.length;
        setSelectedId(getId(list[next]));
        return next;
      });
    }, interval);
  };

  /** 初始化 / 数据变化 */
  useEffect(() => {
    if (!list.length) return;

    setCurrentIndex(0);
    setSelectedId(getId(list[0]));
    startLoop();

    return clearTimer;
  }, [list]);

  /** 鼠标移入：暂停 + 立即选中 */
  const onItemMouseEnter = (index: number) => {
    pausedRef.current = true;
    clearTimer();
    setCurrentIndex(index);
    setSelectedId(getId(list[index]));
  };

  /** 鼠标移出：从当前 index 继续轮播 */
  const onItemMouseLeave = () => {
    if (!pausedRef.current) return;
    pausedRef.current = false;
    startLoop();
  };

  return {
    currentIndex,
    selectedId,
    onItemMouseEnter,
    onItemMouseLeave,
  };
}
